"use strict";
import a from "./index.es119.js";
import n from "./index.es129.js";
import t from "./index.es242.js";
function d(e, i) {
  return n(e, new t.classes.URLSearchParams(), {
    visitor: function(r, s, f, o) {
      return t.isNode && a.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...i
  });
}
export {
  d as default
};
//# sourceMappingURL=index.es241.js.map
